export class Popup {

    constructor ( target = '.js-popup', options = {} ) {
        this.target = target;

        this.options = {
            activeClass: 'js-popup--active',
            button: '.js-popup__close',
            storageID: 'popup-dismissed',
            ...options
        }

        this.$popup = document.querySelector( target );
        this.token = localStorage.getItem( this.options.storageID );
    }

    init () {
        if ( this.$popup ) {
            setTimeout( () => {
                if ( this.token !== this.$popup.id ) {
                    document.body.classList.add('js-no-scroll');
                    document.documentElement.classList.add('js-no-scroll');

                    this.$popup.classList.add( this.options.activeClass )
                    const $buttons = Array.from( this.$popup.querySelectorAll( this.options.button ) );

                    $buttons.forEach( $button => {
                        $button.addEventListener( 'click', () => {
                            localStorage.setItem( this.options.storageID, this.$popup.id );
                            document.body.classList.remove('js-no-scroll');
                            document.documentElement.classList.remove('js-no-scroll');
                            this.$popup.classList.remove( this.options.activeClass )
                        } )
                    } )
                }
            }, 1000 )
        }
    }
}